/**
 * Sticky Header Element Visibility Rules
 * 
 * Controls visibility of sticky header elements (STICKY_HEADER_TABS experiment).
 */

import { AllowedExperimentKey } from '@tenants/types';
import { ExperimentElement, type VisibilityRule } from '../../types';

/**
 * Sticky header visibility rules
 * 
 * Logic:
 * - All sticky header elements: show only when STICKY_HEADER_TABS experiment is active
 * - Applies to all viewports (mobile and desktop)
 */
export const stickyHeaderRules: Partial<Record<ExperimentElement, VisibilityRule>> = {
  [ExperimentElement.STICKY_HEADER_TABS]: {
    showWhen: {
      experiments: [AllowedExperimentKey.STICKY_HEADER_TABS],
    },
  },
  
  [ExperimentElement.STICKY_HEADER_SHARE_BUTTON]: {
    showWhen: {
      experiments: [AllowedExperimentKey.STICKY_HEADER_TABS],
    },
  },
  
  [ExperimentElement.STICKY_HEADER_LIKE_BUTTON]: {
    showWhen: {
      experiments: [AllowedExperimentKey.STICKY_HEADER_TABS],
    },
  },
};
